import OfficerAction from "@common/redux/actions/OfficerAction";

const emergencyServicesHelpers = ({ methods }) => {
  const handleNewOfficer = (value) => {
    methods.setValue("officer", value, { shouldValidate: true });

    // Officer for display in the UI table
    OfficerAction.editOfficer(value);
  };

  const handleRemoveOfficer = () => {
    methods.setValue("officer", null, { shouldValidate: true });

    OfficerAction.editOfficer(null);
  };

  return { handleNewOfficer, handleRemoveOfficer };
};

export default emergencyServicesHelpers;
